module.exports = __webpack_public_path__ + "static/media/pic_fenxi.0d01ebb8.png";